module.exports = __webpack_public_path__ + "files/167212b1519533bc21d271b16ec42d43.mp3";